import React, { useState } from 'react'

import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { IdCategoriesState, typeCategoriesFilters } from 'model/dashboardCategories/dCategoriesReducer'

import {
    dCategoriesSetFiltersAC
} from 'model/dashboardCategories/dCategoriesActionCreators'
import { NULL_VALUE, SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';


// Type
export type typeDCategoriesFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const DCategoriesFilters: React.FC<typeDCategoriesFilters> = ({ setOpenFilterBar, setIsActiveFilters }) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.filters)


    // Deleted SelectBox
    const DELETED = 'deleted'
    const NOT_DELETED = 'notDeleted'
    const deletedValueList: typeValuesListItem[] = [
        { id: NOT_DELETED, name: <Trans>Not deleted</Trans> },
        { id: DELETED, name: <Trans>Deleted</Trans> },
    ]
    const [ deletedValue, setDeletedValue ] = useState<string | null>(filters.deleted === null ? NULL_VALUE.id : filters.deleted ? DELETED : NOT_DELETED)

    const checkIsChangedFiltersHandler = (newFilters: typeCategoriesFilters): boolean => {
        // eslint-disable-next-line eqeqeq
        return !( newFilters.deleted == filters.deleted )
    }

// Submit form
    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const newFilters: typeCategoriesFilters = {
            deleted: deletedValue === DELETED ? true : deletedValue === NOT_DELETED ? false : null,
        }
        if (checkIsChangedFiltersHandler(newFilters)) {
            await dispatch(dCategoriesSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }

        setOpenFilterBar(false)
    }

    // Clear filters
    const onRestoreHandler = () => {

        setDeletedValue(NOT_DELETED)
        setIsActiveFilters(false)
        dispatch(dCategoriesSetFiltersAC({deleted: false}))
    }

    return (
        <>
            <form onSubmit={ (e) => onSubmitHandler(e) }>
                <div className="flex flex-col gap-4">

                    <div>
                        <SelectBox label={ <Trans>Category list</Trans> } valuesList={ deletedValueList }
                                   valueId={ deletedValue } setIdValue={ setDeletedValue }/>
                    </div>


                    <div className="flex gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={ true } type="button" label={ <Trans>Clear</Trans> }
                                onClick={ onRestoreHandler }/>
                        <Button buttonClassName="w-full" type="submit" label={ <Trans>Apply</Trans> }/>
                    </div>

                </div>
            </form>
        </>
    )
}
